import api from './api';

export interface InstallationService {
  id: number;
  title: string;
  model: string;
  price?: number;
  description?: string;
  duration?: number;
  availabilityInfo?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateInstallationServiceDto {
  title: string;
  model: string;
  price?: number;
  description?: string;
  duration?: number;
  availabilityInfo?: string;
  isActive?: boolean;
}

class InstallationServiceService {
  async getAll(): Promise<InstallationService[]> {
    const { data } = await api.get('/installation-services');
    return data;
  }

  async getActive(): Promise<InstallationService[]> {
    const { data } = await api.get('/installation-services/active');
    return data;
  }

  async getById(id: number): Promise<InstallationService> {
    const { data } = await api.get(`/installation-services/${id}`);
    return data;
  }

  async create(dto: CreateInstallationServiceDto): Promise<InstallationService> {
    const { data } = await api.post('/installation-services', dto);
    return data;
  }

  async update(id: number, dto: Partial<CreateInstallationServiceDto>): Promise<InstallationService> {
    const { data } = await api.put(`/installation-services/${id}`, dto);
    return data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/installation-services/${id}`);
  }

  async toggleActive(id: number): Promise<InstallationService> {
    const { data } = await api.patch(`/installation-services/${id}/toggle`, {});
    return data;
  }
}

export const installationServiceService = new InstallationServiceService();
